import AsthaTradeLap from '../../assets/projects/AsthaTrade-Lap.png';
import AsthaTradeMob from '../../assets/projects/AsthaTrade-Mob.png';
import FacebookLap from '../../assets/projects/Facebook-Lap.png';
import FacebookMob from '../../assets/projects/Facebook-Mob.png';
import GlobeXLap from '../../assets/projects/GlobeX-Lap.png';
import GlobeXMob from '../../assets/projects/GlobeX-Mob.png';
import KnittXLap from '../../assets/projects/KnittX-Lap.png';
import KnittXMob from '../../assets/projects/KnittX-Mob.png';
import PortfolioLap from '../../assets/projects/Portfolio-Lap.png';
import PortfolioMob from '../../assets/projects/Portfolio-Mob.png';
import Portfolio1Lap from '../../assets/projects/Portfolio1-Lap.png';
import Portfolio1Mob from '../../assets/projects/Portfolio1-Mob.png';

export const ProjectData = [
  {
    image: KnittXLap,
    transitionImage: KnittXMob,
    title: 'KnittX',
    description:
      'Textile Management App build with React, NodeJS, MongoDB, AntDesign, TailwindCSS and Firebase. It helps textiles companies to create customers, generate invoices and delivery challans.',
    codeLink: 'https://github.com/Vasanth1009/KnittX',
    liveLink: 'https://knittx.vercel.app/',
  },
  {
    image: Portfolio1Lap,
    transitionImage: Portfolio1Mob,
    title: 'Portfolio',
    description: 'My second portfolio build with React, Bootstrap, Tailwind.',
    liveLink: 'https://vpportfolio1.vercel.app/',
  },
  {
    image: FacebookLap,
    transitionImage: FacebookMob,
    title: 'Facebook-GIF Post',
    description:
      'Clone of Facebook feed page build with React, TailwindCSS. Able to create new post with GIF.',
    codeLink: 'https://github.com/Vasanth1009/Facebook-Post-GIF',
    liveLink: 'https://facebook-post-gif.netlify.app/',
  },
  {
    image: PortfolioLap,
    transitionImage: PortfolioMob,
    title: 'Personal Portfolio',
    description: 'My first portfolio build with HTML, CSS, Javascript.',
    codeLink: 'https://github.com/Vasanth1009/Personal-Portfolio',
    liveLink: 'https://vpportfolio.vercel.app/',
  },
  {
    image: AsthaTradeLap,
    transitionImage: AsthaTradeMob,
    title: 'AsthaTrade Demo Website Clone',
    description:
      'Created a end to end design website build only with React, AntDesign.',
    codeLink: 'https://github.com/Vasanth1009/AsthaTrade',
    liveLink: 'https://asthatrade.netlify.app/',
  },
  {
    image: GlobeXLap,
    transitionImage: GlobeXMob,
    title: 'GlobeX',
    description:
      'Webpage word counter build with React, NodeJS, MongoDB, AntDesign, Tailwind and Firebase. It will find the total number of words in a website.',
    codeLink: 'https://github.com/Vasanth1009/GlobeX',
    liveLink: 'https://globex-app.netlify.app/',
  },
];
